/* DZ Link-Leiste - Bedienung mit der Maus (Nachtrag 56b).
   Mobil aendert das Skript nichts: es steigt sofort aus, wenn kein
   feines Zeigegeraet da ist. Ohne JS bleibt die Leiste per Tab
   bedienbar, die Pfeile bleiben dann unsichtbar. */
(function () {
  if (!window.matchMedia || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  document.querySelectorAll('[data-dz-ll]').forEach(function (huelle) {
    var spur = huelle.querySelector('[data-dz-ll-spur]');
    var zurueck = huelle.querySelector('[data-dz-ll-zurueck]');
    var weiter = huelle.querySelector('[data-dz-ll-weiter]');
    if (!spur) return;
    var LUFT = 2; // Rundungsreserve: scrollLeft ist nicht ganzzahlig

    function schalte(knopf, an) {
      if (!knopf) return;
      knopf.setAttribute('aria-hidden', an ? 'false' : 'true');
      knopf.tabIndex = an ? 0 : -1;
    }
    function stand() {
      var rest = spur.scrollWidth - spur.clientWidth;
      var links = spur.scrollLeft > LUFT;
      var rechts = spur.scrollLeft < rest - LUFT;
      huelle.classList.toggle('ist-links', links);
      huelle.classList.toggle('ist-rechts', rechts);
      schalte(zurueck, links);
      schalte(weiter, rechts);
    }
    function schiebe(richtung) {
      spur.scrollBy({ left: richtung * Math.round(spur.clientWidth * 0.6), behavior: 'smooth' });
    }

    if (zurueck) zurueck.addEventListener('click', function () { schiebe(-1); });
    if (weiter) weiter.addEventListener('click', function () { schiebe(1); });
    spur.addEventListener('scroll', stand, { passive: true });

    /* Mausrad: senkrechtes Rad schiebt waagerecht, aber nur solange die
       Spur in diese Richtung noch kann. Am Ende laeuft das Ereignis
       weiter an die Seite - keine Scrollfalle. */
    spur.addEventListener('wheel', function (e) {
      if (e.ctrlKey || Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      var rest = spur.scrollWidth - spur.clientWidth;
      if (rest <= LUFT) return;
      if (e.deltaY < 0 && spur.scrollLeft <= LUFT) return;
      if (e.deltaY > 0 && spur.scrollLeft >= rest - LUFT) return;
      e.preventDefault();
      spur.scrollLeft += e.deltaY;
    }, { passive: false });

    /* Ziehen mit gedrueckter Maus. Ab 5 px gilt es als Ziehen und der
       Klick auf den Knopf darunter wird unterdrueckt - sonst landet man
       nach jedem Schieben auf einer Kollektionsseite. */
    var zieht = false, gezogen = false, startX = 0, startL = 0;
    spur.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      zieht = true; gezogen = false;
      startX = e.clientX; startL = spur.scrollLeft;
    });
    window.addEventListener('mousemove', function (e) {
      if (!zieht) return;
      var d = e.clientX - startX;
      if (!gezogen && Math.abs(d) > 5) gezogen = true;
      if (gezogen) { spur.scrollLeft = startL - d; e.preventDefault(); }
    });
    window.addEventListener('mouseup', function () {
      zieht = false;
      if (gezogen) setTimeout(function () { gezogen = false; }, 0);
    });
    spur.addEventListener('click', function (e) {
      if (gezogen) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    spur.addEventListener('dragstart', function (e) { e.preventDefault(); });

    if (window.ResizeObserver) new ResizeObserver(stand).observe(spur);
    huelle.classList.add('hat-js');
    stand();
  });
})();
